export const isWithinDays = (startDate: Date, endDate: Date, days: number) =>
  Math.abs(endDate.getTime() - startDate.getTime()) <= days * 24 * 60 * 60 * 1000;

export const isWithinMonths = (startDate: Date, endDate: Date, months: number) => {
  if (startDate > endDate) return false;
  startDate.setMonth(startDate.getMonth() + months);
  return endDate <= startDate;
};

export const getPreviousDate = (date1: Date | undefined, date2: Date | undefined): Date | undefined => {
  if (!date1 && !date2) return undefined;
  if (!date1) return date2;
  if (!date2) return date1;
  return date1 < date2 ? date1 : date2;
};
